import { Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import React from "react"
import { t } from "@lingui/macro"
import { RealSuiteNumber } from "@ssc-booking/api-contracts/src"
import * as F from "fp-ts/function"
import * as ROA from "fp-ts/ReadonlyArray"
import useModal from "../ModalProvider/useModal"
import { SanitySuite, ShipDeckPlan } from "../../app-core/_common/sanity/sanity-types"
import VerticalDeckPlan from "../VerticalDeckPlan/VerticalDeckPlan"
import styles from "./DeckPlanModal.module.scss"
import DeckPlanLegend from "./DeckPlanLegend/DeckPlanLegend"

type Props = {
    shipDeckPlan: ShipDeckPlan
    availableSuiteNumbers: readonly RealSuiteNumber[]
    suitesContent: readonly SanitySuite[]
}

const DeckPlanModal: React.FC<React.PropsWithChildren<Props>> = ({
    shipDeckPlan,
    availableSuiteNumbers,
    suitesContent,
}) => {
    const { closeModal } = useModal()
    const modalTitle = `${t({ id: "deck" })} ${shipDeckPlan.deckNumber}`
    const suitesOnDeck = F.pipe(
        suitesContent,
        ROA.filter((x) => (x.deck || []).includes(shipDeckPlan.deckNumber)),
    )

    return (
        <Modal
            title={modalTitle}
            size="small"
            modal={{
                isOpen: true,
                onRequestClose: () => closeModal("closeWithCallback"),
                shouldCloseOnEsc: true,
                shouldCloseOnOverlayClick: false,
            }}
            dataContentName="deck-plan-modal"
        >
            <ModalBody variant="full" paddingTop={false} className={styles.modalBody}>
                <DeckPlanLegend suitesContent={suitesOnDeck} />
                <div className={styles.shipImageContainer}>
                    <VerticalDeckPlan
                        src={shipDeckPlan.deckImageURL}
                        deckPlanNumber={shipDeckPlan.deckNumber}
                        availableSuiteNumbers={availableSuiteNumbers}
                    />
                </div>
            </ModalBody>
        </Modal>
    )
}

export default DeckPlanModal
